import { Injectable } from '@angular/core';

/**
 * Full-page navigation — a reload, not a router hop — so nothing a signed-out
 * session held in memory survives into the next one. Its own service so specs
 * can observe it instead of navigating jsdom.
 */
@Injectable({ providedIn: 'root' })
export class PageNavigator {
  assign(url: string): void {
    window.location.assign(url);
  }
}
